module.exports = __webpack_public_path__ + "assets/next-arrow-blue.svg?ver=b5433724";